import pampLogo from "@/assets/pamp-logo.png";
import { Linkedin, Facebook, Instagram } from "lucide-react";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const socialLinks = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/pamp-recruitment-agency/", icon: Linkedin },
  { name: "X", href: "https://x.com/pamprecruitment", icon: XIcon },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61550770122574", icon: Facebook },
  { name: "Instagram", href: "https://www.instagram.com/pamprecruitment", icon: Instagram },
];

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card py-12">
      <div className="container mx-auto px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4">
              <img src={pampLogo} alt="PAMP Recruitment" className="h-10 w-auto rounded-lg" width="40" height="40" loading="lazy" />
            </div>
            <p className="mb-4 text-sm text-muted-foreground">
              Connecting talent with opportunity across the UK.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${social.name}`}
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-foreground">For Job Seekers</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/jobs" className="hover:text-primary transition-colors">Browse Jobs</a></li>
              <li><a href="/jobs/search" className="hover:text-primary transition-colors">Job Search</a></li>
              <li><a href="/careers" className="hover:text-primary transition-colors">Careers</a></li>
              <li><a href="/locations" className="hover:text-primary transition-colors">Jobs by Location</a></li>
              <li><a href="/cv-registration" className="hover:text-primary transition-colors">Register CV</a></li>
              <li><a href="/job-alerts" className="hover:text-primary transition-colors">Job Alerts</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-foreground">For Employers</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/hire" className="hover:text-primary transition-colors">Hire Talent</a></li>
              <li><a href="/contact" className="hover:text-primary transition-colors">Contact Us</a></li>
              <li><a href="/employers" className="hover:text-primary transition-colors">Supply Partners</a></li>
              <li><a href="/cleaning-staff" className="hover:text-primary transition-colors">Cleaning &amp; Facilities</a></li>
              <li><a href="/sectors/public-sector" className="hover:text-primary transition-colors">Public Sector</a></li>
              <li><a href="/sectors/corporate-fm" className="hover:text-primary transition-colors">Corporate FM</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-foreground">Company</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/about" className="hover:text-primary transition-colors">About Us</a></li>
              <li><a href="/equality-diversity-inclusion" className="hover:text-primary transition-colors">Equality, Diversity &amp; Inclusion Policy</a></li>
              <li><a href="/faq" className="hover:text-primary transition-colors">FAQ</a></li>
              <li><a href="/privacy" className="hover:text-primary transition-colors">Privacy Policy</a></li>
              <li><a href="/cookie" className="hover:text-primary transition-colors">Cookie Policy</a></li>
              <li><a href="/terms" className="hover:text-primary transition-colors">Terms of Service</a></li>
              <li><a href="/health-and-safety" className="hover:text-primary transition-colors">Health &amp; Safety Policy</a></li>
              <li><a href="/environmental-policy" className="hover:text-primary transition-colors">Environmental Policy</a></li>
              <li><a href="/prompt-payment-policy" className="hover:text-primary transition-colors">Prompt Payment Policy</a></li>
              <li><a href="/modern-slavery" className="hover:text-primary transition-colors">Modern Slavery Statement</a></li>
              <li>
                <button 
                  onClick={() => window.dispatchEvent(new Event('openCookiePreferences'))}
                  className="hover:text-primary transition-colors text-left"
                >
                  Manage Cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-8 flex flex-col items-center gap-4 text-sm text-muted-foreground">
          <a
            href="https://www.jobsaware.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="JobsAware"
            className="inline-block"
          >
            <img
              src="https://static.jobsaware.co.uk/logos/partner-light-compact-750.webp"
              alt="JobsAware"
              width="150"
              height="auto"
              className="block dark:hidden h-auto w-[150px]"
              loading="lazy"
            />
            <img
              src="https://static.jobsaware.co.uk/logos/partner-dark-compact-750.webp"
              alt="JobsAware"
              width="150"
              height="auto"
              className="hidden dark:block h-auto w-[150px]"
              loading="lazy"
            />
          </a>
          <p>&copy; 2025 PAMP Recruitment. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
